import { ChangeEvent, useState } from 'react';
import { Button, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Icon } from 'ts-react-feather-icons';

import { acceptableImageType, imageTypeMessage } from 'utils/form';

const useStyles = makeStyles(() => ({
  logo: {
    height: '142px',
    width: '142px',
  },
  avatar: {
    height: '90px',
    width: '90px',
  },
  buttonText: {
    marginLeft: '11px',
  },
  padding: {
    padding: '20px',
  },
  inputError: {
    backgroundColor: '#FFF1F1',
    color: 'red',
  },
}));

type Props = {
  logoUrl: string | null;
  // eslint-disable-next-line @typescript-eslint/ban-types
  setLogo: Function;
  avatarUrl: string | null;
  // eslint-disable-next-line @typescript-eslint/ban-types
  setAvatar: Function;
};

const PartnerLogo = ({ setLogo, logoUrl, avatarUrl, setAvatar }: Props) => {
  const classes = useStyles();
  const [logoErrorMessage, setLogoErrorMessage] = useState('');
  const [avatarErrorMessage, setAvatarErrorMessage] = useState('');
  const [newLogo, setNewLogo] = useState(logoUrl);
  const [newAvatar, setNewAvatar] = useState(avatarUrl);

  const handleLogoChange = (e: ChangeEvent<HTMLInputElement>) => {
    setLogoErrorMessage('');
    const { files } = e.target;
    if (files && files.length) {
      if (acceptableImageType(files[0].type)) {
        setLogo(files && files[0]);
        setNewLogo(URL.createObjectURL(files && files[0]));
      } else {
        setLogoErrorMessage(imageTypeMessage);
      }
    }
  };

  const handleAvatarChange = (e: ChangeEvent<HTMLInputElement>) => {
    setAvatarErrorMessage('');
    const { files } = e.target;
    if (files && files.length) {
      if (acceptableImageType(files[0].type)) {
        setAvatar(files && files[0]);
        setNewAvatar(URL.createObjectURL(files && files[0]));
      } else {
        setAvatarErrorMessage(imageTypeMessage);
      }
    }
  };

  return (
    <div>
      <Grid container>
        <Grid item xs={6} md={12} lg={12}>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            className={classes.padding}
          >
            <Grid item xs={12}>
              <img
                src={newLogo ? newLogo : '/upload-logo.png'}
                className={classes.logo}
                alt="logo"
              />
              <input id="logo" type="file" accept="image" onChange={handleLogoChange} hidden />
            </Grid>
            <Grid item xs={12}>
              <label htmlFor="logo">
                <Button component="span">
                  <Icon name="edit" color="#44D2F2" />
                  <Typography className={classes.buttonText} variant="caption">
                    Edit Logo
                  </Typography>
                </Button>
              </label>
              <div className={classes.inputError}>
                <Typography variant="caption">{logoErrorMessage}</Typography>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6} md={12} lg={12}>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            className={classes.padding}
          >
            <Grid item xs={12}>
              <img
                src={newAvatar ? newAvatar : '/user-icon.svg'}
                className={classes.avatar}
                alt="avatar"
              />
              <input id="avatar" type="file" accept="image" onChange={handleAvatarChange} hidden />
            </Grid>
            <Grid item xs={12}>
              <label htmlFor="avatar">
                <Button component="span">
                  <Icon name="edit" color="#44D2F2" />
                  <Typography className={classes.buttonText} variant="caption">
                    Edit Profile Photo
                  </Typography>
                </Button>
              </label>
            </Grid>
            <div className={classes.inputError}>
              <Typography variant="caption">{avatarErrorMessage}</Typography>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
export default PartnerLogo;
